import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';
import ApprovalsList from './../../components/lists/approvals';

class ApprovalsPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{ApprovalsPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <ApprovalsList />
                    </div>
                </div>
            </div>
        );
    }
}

ApprovalsPage.meta = {
    label: <FormattedMessage id={'evaluations'} defaultMessage={'Evaluations'} />,
    icon: 'done',
    action: () => history.push('/approvals'),
    locations: ['/approvals']
};

export default ApprovalsPage;



// WEBPACK FOOTER //
// ./src/pages/approvals/index.jsx